<ol *ngIf="anchorLinksVisible && !seoEnabled && !hideTitles">
	<li *ngFor="let contentSection of contentSections; trackBy: contentSectionTrackBy" class="anchor-link">
		<a
			[href]="
				(currentPathName$ | async) +
				'#' +
				encode(contentSection.fragmentIdentifier || contentSection.title.text)
			"
			>{{ contentSection.title.text }}</a
		>
	</li>
</ol>

<article *ngIf="!seoEnabled; else seoEnabledTemplate">
	<section
		[ngClass]="{ 'boxed-content': contentSection.alternateStyling }"
		*ngFor="let contentSection of contentSections; let i = index; trackBy: contentSectionTrackBy"
	>
		<a *ngIf="!hideTitles" [name]="encode(contentSection.fragmentIdentifier || contentSection.title.text)">{{
			i + 1 + ". " + contentSection.title.text
		}}</a>
		<div class="paragraph-view" [innerHtml]="getRawSafeHtml(contentSection.body.text)"></div>
	</section>
</article>
<ng-template #seoEnabledTemplate>
	<article>
		<section
			[ngClass]="{ 'boxed-content': contentSection.alternateStyling }"
			*ngFor="let contentSection of contentSections; let i = index; trackBy: contentSectionTrackBy"
		>
			<h2 *ngIf="i == 0 && !hideTitles">{{ contentSection.title.text }}</h2>
			<h3 *ngIf="i != 0 && !hideTitles">{{ contentSection.title.text }}</h3>
			<div class="paragraph-view" [innerHtml]="getRawSafeHtml(contentSection.body.text)"></div>
			<a
				class="button"
				*ngIf="contentSection.ctaUrl && contentSection.ctaLabel"
				[obgRouteLink]="contentSection.ctaUrl"
				>{{ contentSection.ctaLabel }}</a
			>
			<img
				*ngIf="contentSection.image && contentSection.image.src && contentSection.image.alt"
				[src]="contentSection.image.src"
				[alt]="contentSection.image.alt"
			/>
		</section>
	</article>
</ng-template>
